import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/pages/layoutChrome";
import { ModuleFeatureCard } from "@/components/HubModuleCard";
import { resolveModuleNavIcon } from "@/modules/moduleNavIcons";
import { LayoutDashboard } from "lucide-react";

/**
 * Hub secundario del módulo Diseñador — subtarjetas agrupadas bajo una tarjeta principal.
 */
export default function DesignerSecondaryHub({
  title,
  subtitle,
  breadcrumbSuffix,
  cards,
  testId,
  intro,
}) {
  const navigate = useNavigate();
  const cardList = useMemo(() => cards || [], [cards]);

  return (
    <div className="min-h-screen">
      <PageHeader
        title={title}
        subtitle={subtitle}
        breadcrumb={["Módulo Maestro Diseñador", breadcrumbSuffix || title]}
      />
      <div className="p-8 max-w-6xl mx-auto space-y-6" data-testid={testId}>
        {intro ? (
          <p className="text-sm text-slate-600 m-0 leading-relaxed max-w-3xl">{intro}</p>
        ) : null}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {cardList.map((card) => {
            const Icon = resolveModuleNavIcon(card.iconKey, LayoutDashboard);
            return (
              <ModuleFeatureCard
                key={card.path}
                label={card.label}
                description={card.description}
                icon={Icon}
                hasModuleAccess
                accessLoading={false}
                testId={card.testid}
                cardCategory={card.category}
                cardStatus={card.status}
                onEnter={() => navigate(card.path)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
